import { NgModule } from '@angular/core';

import { ApLoggingService } from './logging.service';

/**
 * @ngdoc module
 * @name ApLoggingModule
 * @deprecated - Will be removed in Angular 21. ApLoggingService can be provided directly
 */
@NgModule({
    providers: [ApLoggingService]
})
export class ApLoggingModule {}
